import { PlottableReference, Renderer,  Transform } from '4d-mapper';
import { from, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { Vasat } from 'vasat';

const Cesium = (<any>window).Cesium


/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
export class ArcGisTransformRenderer extends Renderer<Transform>{

  constructor(private viewer:any){
    super()
    this._log();
  }

  onAdd(t:Transform, args?:any){

    var url:string =  t.file('ArcGis')
    var layer = t['proxyMeta'].layer_id

    this._log('onAdd',[t,args, url, layer]);
    if(args && args.onInit) { args.onInit(t); }

    var esri = new Cesium.ArcGisMapServerImageryProvider({
        url : url,
        layers: layer
      });

      if ( esri.errorEvent ) {
        this.monitorEvent('errorEvent',esri.errorEvent);
      }

      if(args && args.onStart) { args.onStart(t,esri); }

      var obj = this.viewer.imageryLayers.addImageryProvider(esri);

      if(args && args.onEnd) { args.onEnd(t,obj); }

      var pr:PlottableReference = {
        plottable:t,
        object: obj
      }
      
      return of(pr)

  }
  onRemove(t:Transform,pr:PlottableReference){
    this.viewer.imageryLayers.remove(pr.object)
  }
}
